
export function UsefulLinks() {
  const bullet = '\u2022 ';
  return (<>
    Phonetics:<br />
    {bullet} <a href='?page=chart-essay'>Phoneme Charts</a>
    <br />
    {bullet} <a href='?page=speech-essay'>Picking Speech Phonemes</a>
    <br />
    {bullet} <a href='?page=rules-essay'>Sound Change Rules</a>
    <br /><br />

    <a href='?page=orthography'>Custom Orthography to IPA</a>
    <br /><br />

    Pronouncing English:<br />
    {bullet} <a href='?page=pronounce-essay'>Pronouncing English is Hard</a>
    <br />
    {bullet} <a href='?page=accent-essay'>Making English Accents</a>
    <br />
    {bullet} <a href='?page=westus-essay'>Making a Western US Accent</a>

    <br /><br />
    <a href='?page=dialog-essay'>Writing Dialog</a>
  </>)
}
